import ReactEChartsCore from 'echarts-for-react/lib/core';
import * as echarts from 'echarts/core';
import { useAppContext } from 'providers/AppProvider';
import { ToolboxComponent, TooltipComponent } from 'echarts/components';
import { PieChart } from 'echarts/charts';
import { CanvasRenderer } from 'echarts/renderers';
import { rgbaColor } from 'helpers/utils';
import { useEffect, useRef } from 'react';
import { usePowerStationFilterStore } from '../stores/PowerStationFilterStore';
import { getRouteDeadlineLabels } from '../Utils';
import dayjs from 'dayjs';

echarts.use([TooltipComponent, ToolboxComponent, PieChart, CanvasRenderer]);

// Calcula o total para percentuais
// const total = seriesData.reduce((sum, item) => sum + item.value, 0);

const RouteDeadlinesChart = () => {
	const { getThemeColor } = useAppContext();
	const chartRef = useRef(null);
	const dataRouteDeadline = getRouteDeadlineLabels();

	const inspectionRecords = usePowerStationFilterStore((state) => state.inspectionRecords);
	const inspectionRouteFilter = usePowerStationFilterStore((state) => state.inspectionRouteFilter);
	const filterActiveAnomalyRecordsByDeadline = usePowerStationFilterStore((state) => state.filterActiveAnomalyRecordsByDeadline);

	const setSeriesData = () => {
		let expired = 0;
		let near = 0;
		let farAway = 0;

		const now = Date.now();

		const inspectionRecordsFiltered = inspectionRecords.filter(x => !x.finished);

		inspectionRecordsFiltered.forEach(item => {
			if (item.expectedEndDate) {
				const parsedDate = dayjs(item.expectedEndDate);
				if (parsedDate.isValid()) {
					const diffDays = (parsedDate.toDate().getTime() - now) / (1000 * 60 * 60 * 24);

					if (diffDays < 0) {
						expired++;
					} else if (diffDays <= 30) {
						near++;
					} else {
						farAway++;
					}
				}
			}
		});

		return [
			{ value: expired, name: dataRouteDeadline[0] },
			{ value: near, name: dataRouteDeadline[1] },
			{ value: farAway, name: dataRouteDeadline[2] },
		];
	};

	const seriesData = setSeriesData();

	const getDefaultOptions = (getThemeColor: (name: string) => string) => {
		const selected: Record<string, boolean> = {};
		seriesData.forEach(item => {
			selected[item.name] = item.value > 0;
		});

		return {
			color: [
				'rgba(255, 0, 0, 0.7)',
				'rgba(255, 255, 0, 0.5)',
				'rgba(0, 255, 0, 0.5)',
			],
			// title: {
			//   text: 'Prazos das Rotas',
			//   left: 'center',
			//   top: '10%'
			// },
			legend: {
				data: dataRouteDeadline,
				bottom: '0px',
				left: '0px',
				orient: 'vertical',
				align: 'left',
				textStyle: {
					color: getThemeColor('gray-800'),
					fontSize: 12
				},
				selected: selected
			},
			toolbox: {
				show: true,
				feature: {
					restore: {
						show: inspectionRouteFilter.length > 0,
						title: 'Limpar filtro'
					},
				}
			},
			series: [
				{
					type: 'pie',
					radius: '50%',
					center: ['50%', '40%'],
					label: {
						formatter: (params: { value: number; }) => {
							return ((params.value / total) * 100).toFixed(1) + '%';
						},
						color: getThemeColor('gray-700')
					},
					data: seriesData,
					emphasis: {
						itemStyle: {
							shadowBlur: 10,
							shadowOffsetX: 0,
							shadowColor: rgbaColor(getThemeColor('gray-600'), 0.5)
						}
					}
				}
			],
			tooltip: {
				trigger: 'item',
				padding: [7, 10],
				backgroundColor: getThemeColor('gray-100'),
				borderColor: getThemeColor('gray-300'),
				textStyle: { color: getThemeColor('gray-1100') },
				borderWidth: 1,
				transitionDuration: 0,
				axisPointer: {
					type: 'none'
				}
			}
		}
	};

	const total = seriesData.reduce((sum, item) => sum + item.value, 0);

	const handleClick = (params: any) => {
		// filterAnomalyRecords([params.name]);
	}

	const handleLegendClick = (params: any) => {
		// const selectedMap = params.selected;
		// const activeLegends = Object.keys(selectedMap).filter(name => selectedMap[name]);
		// filterAnomalyRecords(activeLegends);
	};

	const handleRestore = (params: any) => {
		// filterAnomalyRecords([]);
	}

	return (
		<ReactEChartsCore
			echarts={echarts}
			option={getDefaultOptions(getThemeColor)}
			style={{ minHeight: '350px', width: '100%' }}
			ref={chartRef}
			onEvents={{
				click: handleClick,
				legendselectchanged: handleLegendClick,
				restore: handleRestore
			}}
		/>
	);
};

export default RouteDeadlinesChart;
